import notfound from '../../../Assets/images/il-empty.svg';
import React, { useEffect, useRef, useState } from 'react';
import { usePagination, useSortBy, useTable } from 'react-table';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import Button from "../../../Components/Button/Button";
import Exports from '../../../Components/Exports/Exports';
import { EnumEstadoEventoConcesion, EnumEstadoEventoConcesionDesc, EnumEstadoAutorizacionInformeConserv } from '../../../Utils/Enumeradores/ComunEnum';
import moment from 'moment';
import RangeDatePicker from '../../../Components/RangeDatePicker/RangeDatePicker';
import { Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Select from 'react-select';
import SelectCheckField from '../../../Components/SelectCheckField/SelectCheckField';
import Tooltip from 'react-bootstrap/Tooltip';
import BitacoraIrdmField from './BitacoraIrdmField';
import PaginationComponent from '../../../Components/PaginationTableServer/PaginationTableServer';
import validations from '../../../Utils/Validations/Validations';
import { useLoading } from '../../../Hooks/useLoading';
import { useRegistroTDR } from '../../../Hooks/useRegistroTDR';
import { useNavigate } from 'react-router-dom';
import ModalNuevoEventoConcesion from './ModalNuevoEventoConcesion';
import { ObtenerIndicadoresExigenciasPorAreaNegocio } from '../Services/ObtenerIndicadoresExigenciasPorAreaNegocio';

const ExportIndicatorOption = (props) => {
	const { innerProps, isSelected, label } = props;

	return (
		<div {...innerProps} className={`datamart-filter-toolbar__option ${isSelected ? 'is-selected' : ''}`}>
			<span className="datamart-filter-toolbar__radio" aria-hidden="true"></span>
			<span>{label}</span>
		</div>
	);
};

const BitacoraEventosConcesionTable = ({ columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, handlerModal, datosInformeConservacion, setDatosInformeConservacion }) => {
	const {
getTableProps
, getTableBodyProps
, headerGroups
, prepareRow
, page
, pageCount
, gotoPage
, setSortBy
, state: { pageIndex, pageSize, sortBy }
	} = useTable(
		{
			columns
			, data
			, initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
			, manualPagination: true
			, pageCount: controlledPageCount
			, autoResetPage: false
			, autoResetSortBy: false
			, manualSortBy: true
		},
		useSortBy,
		usePagination
	);

	const { usuario } = useLogin();
	const { crearRegistroTDR } = useRegistroTDR();
	const addLoading = useLoading();
	const [esBuscar, setEsBuscar] = useState(false);
	const [esPeticion, setEsPeticion] = useState(true);
	const [call, setCall] = useState(false);
	const [showModalNuevoEvento, setShowModalNuevoEvento] = useState(false);
	const [showModalExportacion, setShowModalExportacion] = useState(false);
	const [indicadorExportacion, setIndicadorExportacion] = useState(null);
	const [idbimAplicado, setIdbimAplicado] = useState("");
	const formikRef = useRef();
	const valoresFormularioEnvioRef = useRef(null);
	
	const mapping = {
		[EnumEstadoAutorizacionInformeConserv.Autorizado]: EnumEstadoEventoConcesion.Autorizado,  //Aquí igualamos los estados
		[EnumEstadoAutorizacionInformeConserv.Rechazado]: EnumEstadoEventoConcesion.Rechazado, 
		[EnumEstadoAutorizacionInformeConserv.Pendiente]: EnumEstadoEventoConcesion.Pendiente
	};

const estadoAutorizacionId2 = datosInformeConservacion?.estadoAutorizacionId
    ? mapping[datosInformeConservacion.estadoAutorizacionId]
    : null;

	const [indicadorTotal, setIndicadorTotal] = useState([]);
	const [listadoIndicadoresId, setListadoIndicadoresId] = useState([]);
	const [listadoExigenciasId, setListadoExigenciasId] = useState([]);
	const listaEstadoAutorizacion = [{ value: EnumEstadoEventoConcesion.Pendiente, label: EnumEstadoEventoConcesionDesc.Pendiente },
	{ value: EnumEstadoEventoConcesion.Autorizado, label: EnumEstadoEventoConcesionDesc.Autorizada },
	{ value: EnumEstadoEventoConcesion.Rechazado, label: EnumEstadoEventoConcesionDesc.Rechazada }];
	const listaEstadoEvento = [{ value: 1, label: "Cumpliendo" }
		, { value: 0, label: "Incumpliendo" }];
	const [listaAreaNegocioSeleccion] = useState(usuario ? usuario.listaAreaNegocio ? usuario.listaAreaNegocio.map(x => { return { value: x.id.toString(), label: x.descripcion } }) : [] : []);
	const exportIndicatorComponents = { Option: ExportIndicatorOption };
	const [initialValues, setInitialValues] = useState({
		business: listaAreaNegocioSeleccion.map(x => { return x.value.toString() }),
		indicadores: listadoIndicadoresId ? listadoIndicadoresId.map(x => { return x.value }) : '',
		exigencia: '',
		periodo2: datosInformeConservacion ?
			[
				datosInformeConservacion.fechaDesde ? new Date(datosInformeConservacion.fechaDesde) : moment().subtract(1, 'M').toDate(),
				datosInformeConservacion.fechaHasta ? new Date(datosInformeConservacion.fechaHasta) : new Date()
			] : [moment().subtract(1, 'M').toDate(), new Date()]
		, estado: datosInformeConservacion ? [estadoAutorizacionId2] : listaEstadoAutorizacion.map(x => { return Number(x.value) })
		, estadoEvento: listaEstadoEvento.map(x => { return Number(x.value) })
		, irdm: ''
	});

	const obtenerExigenciasPorIndicadores = (indicadores, selectedIds) => {
		const ids = Array.isArray(selectedIds) ? selectedIds.map(Number) : indicadores.map((indicador) => indicador.indicadorId);

		return indicadores
			.filter((indicador) => ids.includes(Number(indicador.indicadorId)))
			.flatMap((indicador) =>
				(indicador.exigencias || []).map((exigencia) => ({
					value: exigencia.id,
					label: `${indicador.sigla} - ${exigencia.sigla} - ${exigencia.descripcion}`,
				}))
			);
	};

	const actualizarListasIndicadorExigencia = (indicadores, selectedIds, setFieldValue) => {
		const indicadoresOptions = indicadores.map((indicador) => ({
			value: indicador.indicadorId,
			label: `${indicador.sigla}`,
		}));
		const exigenciasOptions = obtenerExigenciasPorIndicadores(indicadores, selectedIds);

		setIndicadorTotal(indicadores);
		setListadoIndicadoresId(indicadoresOptions);
		setListadoExigenciasId(exigenciasOptions);

		if (setFieldValue) {
			const indicadoresValue = selectedIds && selectedIds.length > 0 ? selectedIds.map(Number) : indicadoresOptions.map((x) => x.value);
			setFieldValue("indicadores", indicadoresValue);
			setFieldValue("exigencia", "");
		}
	};

	const cargarIndicadoresExigencias = async (areaIds, setFieldValue) => {
		const idsArea = Array.isArray(areaIds) ? areaIds.map(Number) : [];
		if (idsArea.length === 0) {
			actualizarListasIndicadorExigencia([], undefined, setFieldValue);
			return;
		}

		const respuestas = await Promise.all(
			idsArea.map((areaNegocioId) =>
				ObtenerIndicadoresExigenciasPorAreaNegocio({
					idUsuario: usuario.id,
					areaNegocioId,
				})
			)
		);

		const indicadores = respuestas
			.filter((respuesta) => respuesta && respuesta.status === 200 && Array.isArray(respuesta.data))
			.flatMap((respuesta) => respuesta.data);
		const indicadoresUnicos = indicadores.reduce((acc, indicador) => {
			const actual = acc.get(indicador.indicadorId);
			if (!actual) {
				acc.set(indicador.indicadorId, {
					...indicador,
					exigencias: indicador.exigencias || [],
				});
				return acc;
			}

			const exigencias = [...(actual.exigencias || []), ...(indicador.exigencias || [])];
			acc.set(indicador.indicadorId, {
				...actual,
				exigencias: [...new Map(exigencias.map((exigencia) => [exigencia.id, exigencia])).values()],
			});
			return acc;
		}, new Map());
		actualizarListasIndicadorExigencia([...indicadoresUnicos.values()], undefined, setFieldValue);
	};

	useEffect(() => {
		if (esPeticion) {
			if (listadoIndicadoresId.length > 0 && usuario.listaAreaNegocio.length > 0) {
				BuscarEventosConcesion(initialValues);
			}
		}
	}, [usuario.listaAreaNegocio, listadoIndicadoresId, esPeticion])

	const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex
			, cantidadRegistros: pageSize
			, orderByAscending: false
			, ordenadoPor: "fechaCreacion"
		},
		datosBusqueda: {
			idUsuario: usuario.id
			, fechaInicio: moment().subtract(1, 'M').format()
			, fechaFin: moment().format()
			, exportacion: false
			, idNegocio: listaAreaNegocioSeleccion.map(x => { return Number(x.value) })
			, idIndicador: listadoIndicadoresId ? listadoIndicadoresId.map(x => { return x.value }) : []
			, IdExigencia: []
			, estado: listaEstadoAutorizacion.map(x => { return Number(x.value) })
			, estadoEvento: listaEstadoEvento.map(x => { return Number(x.value) })
			, IdBim: ""
			, exportacionIdIndicador: null
		}
	});
	valoresFormularioEnvioRef.current = valoresFormularioEnvio;

	useEffect(() => {
		const business = formikRef.current?.values?.business !== undefined
			? formikRef.current.values.business
			: listaAreaNegocioSeleccion.map(x => { return x.value.toString() });
		const tieneAreaSeleccionada = Array.isArray(business) && business.length > 0;

		if (listadoIndicadoresId.length > 0) {
			let indi = tieneAreaSeleccionada && listadoIndicadoresId ? listadoIndicadoresId.map(x => { return x.value }) : '';
			if (datosInformeConservacion && listadoIndicadoresId) {
				indi = [datosInformeConservacion.indicadorId]
			}
			setInitialValues(values => ({
				...values
				, business: business
				, indicadores: indi,
				exigencia: '',
			}));
			if (tieneAreaSeleccionada) {
				setEsBuscar(true);
			}
		} else {
			setInitialValues(values => ({
				...values
				, business: business
				, indicadores: '',
				exigencia: '',
			}));
		}

	}, [listadoIndicadoresId])

	useEffect(() => {
		let valoresNuevos = valoresFormularioEnvio;
		valoresNuevos.datosBusqueda.idNegocio = listaAreaNegocioSeleccion.map(x => { return Number(x.value) });
		valoresNuevos.datosBusqueda.idIndicador = listadoIndicadoresId ? listadoIndicadoresId.map(x => { return x.value }) : [];
		setValoresFormularioEnvio(valoresNuevos);
		setEsBuscar(false);
	}, [esBuscar])

	useEffect(() => {
		if (valoresFormularioEnvio.datosBusqueda.idIndicador.length > 0) {
			setEsPeticion(false);
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination(values => ({
				...values
				, sortBy: sortBy
			}));
		}
	}, [pageIndex, sortBy])


	const obtenerIndicadoresExportacion = () => {
		const idsSeleccionados = (valoresFormularioEnvioRef.current?.datosBusqueda?.idIndicador || []).map(Number);

		return listadoIndicadoresId
			.filter((indicador) => idsSeleccionados.includes(Number(indicador.value)))
			.map((indicador) => ({
				value: Number(indicador.value),
				label: indicador.label,
			}));
	};

	const descargar = () => {
		const indicadoresExportacion = obtenerIndicadoresExportacion();
		if (indicadoresExportacion.length === 1) {
			const formularioExportacion = {
				...valoresFormularioEnvioRef.current,
				paginacion: {
					...valoresFormularioEnvioRef.current.paginacion,
				},
				datosBusqueda: {
					...valoresFormularioEnvioRef.current.datosBusqueda,
					exportacionIdIndicador: indicadoresExportacion[0].value,
				},
			};
			fetchData({ formulario: formularioExportacion, pageIndex: pageIndex, sortBy, exportacion: true });
			return;
		}

		setIndicadorExportacion(null);
		setShowModalExportacion(true);
	};

	const confirmarDescarga = () => {
		if (!indicadorExportacion) {
			return;
		}

		const formularioExportacion = {
			...valoresFormularioEnvioRef.current,
			paginacion: {
				...valoresFormularioEnvioRef.current.paginacion,
			},
			datosBusqueda: {
				...valoresFormularioEnvioRef.current.datosBusqueda,
				exportacionIdIndicador: indicadorExportacion.value,
			},
		};
		fetchData({ formulario: formularioExportacion, pageIndex: pageIndex, sortBy, exportacion: true });
		setShowModalExportacion(false);
		setIndicadorExportacion(null);
	};

	const navigate = useNavigate();


	// Sincronizar el valor de la referencia con el estado

	function BuscarEventosConcesion(values, botonBuscar = false) {
		const startTime = new Date();
		let formEnvio = valoresFormularioEnvio;
		formEnvio.paginacion.numeroPagina = 0;
		formEnvio.paginacion.orderByAscending = false;
		formEnvio.paginacion.ordenadoPor = "fechaCreacion";

		formEnvio.datosBusqueda.idNegocio = values.business.map(Number);
		formEnvio.datosBusqueda.fechaInicio = values.periodo2[0];
		formEnvio.datosBusqueda.fechaFin = values.periodo2[1];
		formEnvio.datosBusqueda.idIndicador = values.indicadores !== "" ? values.indicadores.map(x => { return Number(x) }) : []
		formEnvio.datosBusqueda.IdExigencia = values.exigencia !== "" ? values.exigencia.map(x => { return Number(x) }) : []
		formEnvio.datosBusqueda.estado = values.estado !== "" ? values.estado.map(x => { return Number(x) }) : []
		formEnvio.datosBusqueda.estadoEvento = values.estadoEvento !== "" ? values.estadoEvento.map(x => { return Number(x) }) : []
		const idbim = (values.irdm || "").trim();
		formEnvio.datosBusqueda.IdBim = idbim
		formEnvio.datosBusqueda.exportacionIdIndicador = null;
		setIdbimAplicado(idbim);

		const fetchData = async () => {

			await Promise.all([
				setValoresFormularioEnvio(formEnvio),
			]);
			valoresFormularioEnvioRef.current = formEnvio;

			const endTime = new Date();
			const tdrId = 20;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};
		if (botonBuscar === true) {
			setDatosInformeConservacion(null);
			navigate('/bitacora/eventos_concesion', { replace: true, state: null });
		}

		fetchData();
		setPagination({
			pageIndex: formEnvio.paginacion.numeroPagina,
			pageSize: formEnvio.paginacion.cantidadRegistros,
			sortBy: []
		});
		setSortBy([]);
		gotoPage(0);
	};

	function obtenerValoresInicialesFiltros() {
		return {
			business: listaAreaNegocioSeleccion.map(x => { return x.value.toString() }),
			indicadores: listadoIndicadoresId ? listadoIndicadoresId.map(x => { return x.value }) : '',
			exigencia: '',
			periodo2: [moment().subtract(1, 'M').toDate(), new Date()],
			estado: listaEstadoAutorizacion.map(x => { return Number(x.value) }),
			estadoEvento: listaEstadoEvento.map(x => { return Number(x.value) }),
			irdm: ''
		};
	}

	function limpiarIdbimAplicado() {
		const values = obtenerValoresInicialesFiltros();
		formikRef.current?.resetForm({ values });
		setInitialValues(values);
		BuscarEventosConcesion(values, true);
	}

	useEffect(() => {
		if (call) {
			fetchData({ formulario: valoresFormularioEnvio, pageIndex: pageIndex, sortBy, exportacion: false });
			setCall(false);
		}
	}, [call])

	useEffect(() => {

		setCall(true);
	}, [datosInformeConservacion])

	useEffect(() => {
		setInitialValues(values => ({
			...values
			, business: listaAreaNegocioSeleccion ? listaAreaNegocioSeleccion.map(x => { return x.value.toString() }) : ''
		}));
		if (listaAreaNegocioSeleccion.length > 0) {
			cargarIndicadoresExigencias(listaAreaNegocioSeleccion.map(x => { return x.value }));
		}
	}, [listaAreaNegocioSeleccion])

	const mostrarModal = (e, row) => {
		e.preventDefault();
		handlerModal(row);
	}

	function changeAreaNegocio(e, setFieldValue) {
		formikRef.current.setFieldValue('business', e);
		if (!Array.isArray(e) || e.length == 0) {
			setFieldValue("business", "");
			setFieldValue("indicadores", "");
			setFieldValue("exigencia", "");
			setInitialValues(values => ({
				...values,
				business: '',
				indicadores: '',
				exigencia: '',
			}));
			actualizarListasIndicadorExigencia([], undefined, setFieldValue);
			return;
		}
		cargarIndicadoresExigencias(e, setFieldValue);
	}

	function changeIndicador(e, setFieldValue) {
		const exigenciasFiltradas = obtenerExigenciasPorIndicadores(indicadorTotal, e);
		setListadoExigenciasId(exigenciasFiltradas);
		setFieldValue("indicadores", e);
		setFieldValue("exigencia", "");
	}

	const realizarBusqueda = () => {
		addLoading(true);
		if (formikRef.current.values.business.length > 0) {
			cargarIndicadoresExigencias(formikRef.current.values.business.map(x => { return Number(x) }));
		}
		setTimeout(() => {
			addLoading(false);
		}, "400");
	};

	const BusquedaIndicadorBlur = () => {
		realizarBusqueda();
	};

	return (
		<div>
			<div className={`d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3 ${idbimAplicado ? 'mb-0' : 'mb-5'}`}>
				<Formik
					enableReinitialize
					initialValues={initialValues}
					innerRef={formikRef}
					validate={validations}
					onSubmit={(values) => {
						BuscarEventosConcesion(values, true);
					}}
				>
					{({ values, setFieldValue, setFieldTouched, }) => (
						<Form className="form mb-0">
							<div className="tools order-1 order-lg-0 align-items-start">
								<SelectCheckField
									name="business"
									label='Área de negocio'
									options={listaAreaNegocioSeleccion}
									onChange={(e, value) => { changeAreaNegocio(value, setFieldValue) }}
									onBlur={BusquedaIndicadorBlur}
									isMulti={true}
									backdrop="static"
								/>
								<SelectCheckField
									name="indicadores"
									label='Indicadores'
									options={listadoIndicadoresId}
									onChange={(e, value) => { changeIndicador(value, setFieldValue) }}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<SelectCheckField
									name="exigencia"
									label='Exigencia'
									options={listadoExigenciasId}
									onChange={setFieldValue}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<RangeDatePicker
									startMaxDate={new Date()}
									startMinDate={null}
									endMaxDate={new Date()}
									endMinDate={null}
									name="periodo2"
									onChange={setFieldValue}
									onBlur={setFieldTouched}
								/>
								<SelectCheckField
									name="estadoEvento"
									label='Estado Evento'
									options={listaEstadoEvento}
									onChange={setFieldValue}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<SelectCheckField
									name="estado"
									label='Estado Autorización IF'
									options={listaEstadoAutorizacion}
									onChange={setFieldValue}
									onBlur={setFieldTouched}
									isMulti={true}
								/>
								<div className="bitacora-irdm-filter">
									<BitacoraIrdmField
										name="irdm"
										label="IDBIM"
										type="text"
										placeholder="Ingresar"
										autoComplete="off"
									/>
								</div>
								<Button type="submit" design="btn-primary">Buscar</Button>
							</div>
						</Form>
					)}
				</Formik>
				<div className="bitacora-filter-actions order-0 order-lg-1">
					<OverlayTrigger
						placement="bottom"
						overlay={<Tooltip id="tooltip-agregar-evento" className="bitacora-add-event-tooltip">Agregar nuevo evento</Tooltip>}
					>
						<span className="d-inline-flex">
							<Button type="button" design="btn--icon bitacora-filter-actions__add" onClick={() => setShowModalNuevoEvento(true)}>
								<svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
									<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									<path d="M12 8v7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
									<path d="M8.5 11.5h7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
								</svg>
							</Button>
						</span>
					</OverlayTrigger>
					<div className="exports" style={{ visibility: data.length > 0 ? 'visible' : 'hidden' }}>
						<Exports descargar={() => descargar()} />
					</div>
				</div>
			</div>
			<ModalNuevoEventoConcesion
				show={showModalNuevoEvento}
				onHide={() => setShowModalNuevoEvento(false)}
				onSuccess={() => fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy, exportacion: false })}
			/>
			<Modal
				show={showModalExportacion}
				onHide={() => {
					setShowModalExportacion(false);
					setIndicadorExportacion(null);
				}}
				centered
				dialogClassName="bitacora-export-modal"
				contentClassName="bitacora-export-modal__content"
			>
				<Modal.Body className="bitacora-export-modal__body">
					<div className="bitacora-export-modal__header">
						<h5>Descarga informe de eventos</h5>
						<button
							type="button"
							className="bitacora-export-modal__close"
							onClick={() => {
								setShowModalExportacion(false);
								setIndicadorExportacion(null);
							}}
							aria-label="Cerrar"
						>
							<i className="ico-close" aria-hidden="true"></i>
						</button>
					</div>
					<p className="bitacora-export-modal__description">
						La selección de un único indicador mejora el rendimiento del sistema y permite una descarga de informes más rápida y eficiente.
					</p>
					<div className="form-floating">
						<div className="bitacora-export-modal__field simple-select">
							<label htmlFor="bitacora-export-indicador">Indicador</label>
							<Select
								classNamePrefix="selector"
								inputId="bitacora-export-indicador"
								name="indicadorExportacion"
								options={obtenerIndicadoresExportacion()}
								value={indicadorExportacion}
								onChange={setIndicadorExportacion}
								placeholder="Seleccionar"
								noOptionsMessage={() => "Sin opciones"}
								isSearchable={false}
								components={exportIndicatorComponents}
							/>
						</div>
					</div>
					<div className="bitacora-export-modal__actions">
						<Button
							type="button"
							design="btn--outline btn--pewter-blue bitacora-export-modal__action bitacora-export-modal__action--clear"
							onClick={() => setIndicadorExportacion(null)}
						>
							Limpiar
						</Button>
						<Button
							type="button"
							design="btn-primary bitacora-export-modal__action bitacora-export-modal__action--confirm"
							onClick={confirmarDescarga}
						>
							Confirmar
						</Button>
					</div>
				</Modal.Body>
			</Modal>
			{idbimAplicado &&
				<div style={{ marginTop: "20px", marginBottom: "24px" }}>
					<span className="datamart-applied-filter">
						<span className="datamart-applied-filter__label">{idbimAplicado}</span>
						<button type="button" className="datamart-applied-filter__close" onClick={limpiarIdbimAplicado} aria-label="Limpiar filtro IDBIM">
							<i className="ico-close"></i>
						</button>
					</span>
				</div>
			}
			<div className="table-responsive brd-top">
				<table className="table" {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup) => {
							const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
							return (
							<tr key={hgKey} {...hgProps}>
								{headerGroup.headers.map((column) => {
									const colHeaderProps = data.length > 0
										? column.getHeaderProps(column.getSortByToggleProps(), { className: column.className })
										: column.getHeaderProps();
									const { key: colKey, ...colProps } = colHeaderProps;
									return data.length > 0 ? (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
												<>
													{column.isSorted ?
														(column.isSortedDesc && data.length > 0 ?
															<i className="ico-chevron-down"></i>
															:
															<i className="ico-chevron-up"></i>
														) :
														<>
															<i className="ico-sort fs-7"></i>
														</>
													}
												</>
											</span>
										</th>
									) : (
										<th key={colKey} {...colProps}>
											<span className="d-flex align-items-center gap-1">
												{column.render('Header')}
											</span>
										</th>
									)
								})}
								<th className="text-center">Detalle</th>
							</tr>
							)
						})}
					</thead>
					<tbody {...getTableBodyProps()}>
						{
							page.length > 0 && page.map((row) => {
								prepareRow(row)
								const { key: rowKey, ...rowProps } = row.getRowProps();
								return (
									<tr key={rowKey} {...rowProps}>
										{row.cells.map((cell) => {
											const { key: cellKey, ...cellProps } = cell.getCellProps({
												className: cell.column.className
											});
											return <td key={cellKey} {...cellProps}>
												{cell.render('Cell')}
											</td>
										})}
										<td className="text-center">
											<button className="link text-pewter-blue fs-4" onClick={(e) => mostrarModal(e, row.original)}>
												<i className="ico-search"></i>
											</button>
										</td>
									</tr>
								)
							}) || <tr><td colSpan={headerGroups[0].headers.length + 1}>
								<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
									<img className="mb-3" src={notfound} alt="" />
									<p className='mb-0 text-primary'>No se encuentran resultados de tu búsqueda.</p>
								</div>
							</td></tr>
						}
					</tbody>
				</table>
			</div>
			{
				data.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={false}
					setPagination={setPagination}
				/>
			}
		</div>
	)
}

export default BitacoraEventosConcesionTable;
